<template>
  <page-template>
    <board :is-fold="isFold"
           :http-options="httpOptions"
           :config="config"
           :insert-row-function="() => insertRow('createEmptyAroma')"
           :delete-row-function="(rows) => deleteRow('deleteAromas', rows)"
           :disabled-play-button="true"/>
  </page-template>
</template>

<script>
import Vue from 'vue';

import config from './Config';
import AromaEditor from './detail-row/AromaEditor';
import CommonBoardItems from '../CommonBoardItems';

Vue.component(config.detailRowComponentName, AromaEditor);

export default {
  name: 'BoardAroma',
  mixins: [CommonBoardItems],
  data() {
    return {
      config,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/spa/components/board/aroma/BoardAroma.vue